module.exports = __webpack_public_path__ + "img/bottom_hk.446f7a26.png";